import { Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IonInput, ModalController } from '@ionic/angular';
import { getSelectionMarkColorHex, SelectionMarkColor } from '@tcc-mono/vandijk/shared/data-access/models';
import { AnimalSelectionRepository } from '@tcc-mono/vandijk/shared/data-access/state';
import { take } from 'rxjs';

@Component({
  templateUrl: './animal-selection-new-animal-dialog.component.html',
  styleUrls: ['./animal-selection-new-animal-dialog.component.scss']
})
export class AnimalSelectionNewAnimalDialogComponent implements OnInit {
  private readonly _fb: FormBuilder = inject(FormBuilder);
  private readonly _modalCtrl: ModalController = inject(ModalController);
  private readonly _repo: AnimalSelectionRepository = inject(AnimalSelectionRepository);

  @Input() public selectionId: number;

  public form: FormGroup;
  /** Alleen kleuren die voor deze selectie aanstaan (voor snel kiezen). */
  public usedColors: SelectionMarkColor[] = [];

  @ViewChild('lifeNumberInput') public lifeNumberInput: IonInput;

  public ngOnInit(): void {
    this.form = this._initForm();
    if (this.selectionId) {
      this._repo.getSelectionMarkColorsForSelection(this.selectionId).pipe(take(1)).subscribe(colors => {
        this.usedColors = (colors || []).filter(c => c.used !== false);
        const firstUsed = this.usedColors[0]?.value ?? null;
        if (firstUsed) {
          this.form.get('selection_mark_color')?.setValue(firstUsed);
        }
      });
    }
  }

  public getMarkColorHex(value: string): string {
    return getSelectionMarkColorHex(value);
  }

  public ionViewDidEnter(): void {
    this.lifeNumberInput?.setFocus();
  }

  public save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const value = this.form.value;
    this._modalCtrl.dismiss({
      country_code: value.country_code,
      identification_number: value.identification_number,
      selection_mark_color: value.selection_mark_color ?? null
    });
  }

  private _initForm(): FormGroup {
    return this._fb.group({
      country_code: ['NL', [Validators.required]],
      identification_number: [null, [Validators.required]],
      selection_mark_color: [null as string | null]
    });
  }
}
